import * as React from 'react';
import { createElement, FC, ReactNode } from 'react';
import { Box, Card, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import cartouche from './cartouche.png';
import cartoucheDark from './cartoucheDark.png';
import { useLocale } from 'react-admin';

interface Props {
	icon: FC<any>;
	to: any;
	title?: string;
	subtitle?: string | number;
	children?: ReactNode;
}

const useStyles = makeStyles(theme => ({
	card: {
		minHeight: 52,
		display: 'flex',
		flexDirection: 'column',
		flex: '1',
		'& a': {
			textDecoration: 'none',
			color: 'inherit'
		}
	},
	main: (props: Props) => ({
		overflow: 'inherit',
		padding: 16,
		background: `url(${
			theme.palette.type === 'dark' ? cartoucheDark : cartouche
		}) no-repeat`,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		'& .icon': {
			color: theme.palette.type === 'dark' ? 'inherit' : '#dc2440'
		}
	}),
	title: {}
}));

const CardWithIcon = (props: Props) => {
	const { icon, title, subtitle, to, children } = props;
	const classes = useStyles(props);

	const locale = useLocale();
	const dir = locale === 'he' || locale === 'ar' ? 'rtl' : 'ltr';

	return (
		<Card className={classes.card}>
			<Link to={to}>
				<div className={classes.main} style={{ flexDirection: dir === 'rtl' ? 'row' : 'row-reverse' }}>
					<Box textAlign="right">
						<Typography
							className={classes.title}
							color="textSecondary"
						>
							{title}
						</Typography>
						<Typography variant="h5" component="h2">
							{subtitle || ' '}
						</Typography>
					</Box>
					<Box width="3em" className="icon">
						{createElement(icon, { fontSize: 'large' })}
					</Box>
				</div>
			</Link>
			{children && <Divider/>}
			{children}
		</Card>
	);
};

export default CardWithIcon;
